'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSimilarItems = exports.getSimilarItemIds = exports.LOAD_SIMILAR_ITEMS_SUCCESS = exports.LOAD_SIMILAR_ITEMS_REQUEST = exports.LOAD_SIMILAR_ITEMS_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

exports.default = reducer;
exports.fetchSimilarItemsIfNeeded = fetchSimilarItemsIfNeeded;

var _api = require('../api');

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _user = require('./user');

var _config = require('./config');

var _cardData = require('./cardData');

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_SIMILAR_ITEMS_FAIL = exports.LOAD_SIMILAR_ITEMS_FAIL = 'la/domain/similarItems/LOAD_FAIL';
var LOAD_SIMILAR_ITEMS_REQUEST = exports.LOAD_SIMILAR_ITEMS_REQUEST = 'la/domain/similarItems/LOAD_REQUEST';
var LOAD_SIMILAR_ITEMS_SUCCESS = exports.LOAD_SIMILAR_ITEMS_SUCCESS = 'la/domain/similarItems/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOAD_SIMILAR_ITEMS_FAIL:
            return (0, _extends5.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, [action.meta.itemId])
            });
        case LOAD_SIMILAR_ITEMS_REQUEST:
            return (0, _extends5.default)({}, state, {
                loading: (0, _union2.default)(state.loading, [action.payload])
            });
        case LOAD_SIMILAR_ITEMS_SUCCESS:
            return (0, _extends5.default)({}, state, {
                byId: (0, _extends5.default)({}, state.byId, (0, _defineProperty3.default)({}, action.meta.itemId, action.payload.itemIDs)),
                loaded: (0, _extends5.default)({}, state.loaded, (0, _defineProperty3.default)({}, action.meta.itemId, action.meta.actionTime)),
                loading: (0, _difference2.default)(state.loading, [action.meta.itemId])
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.similarItems;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

// takes in a (state, id) and returns data
var getSimilarItemIds = exports.getSimilarItemIds = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || [];
});

// takes in a (state, id) and returns load time
var getLoadTimeForSimilarItems = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

// takes in a (state, id) and returns if data is loading
var isSimilarItemsLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var getSimilarItems = exports.getSimilarItems = function getSimilarItems(state, itemId, limit) {
    var similarItemIds = getSimilarItemIds(state, itemId);
    similarItemIds = similarItemIds.filter(function (id) {
        return id !== itemId;
    });
    similarItemIds = similarItemIds.slice(0, limit);
    return (0, _cardData.getItemCardDatas)(state, similarItemIds);
};

var shouldFetchSimilarItems = function shouldFetchSimilarItems(state, itemId) {
    if (!itemId) return false;
    var item = getSimilarItems(state, itemId);
    if (item.length) {
        var loaded = getLoadTimeForSimilarItems(state, itemId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isSimilarItemsLoading(state, itemId);
    return !loading;
};

/* ACTION CREATORS */
var loadSimilarItems = function loadSimilarItems(similarItemInfo) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: similarItemInfo.itemId,
                                type: LOAD_SIMILAR_ITEMS_REQUEST
                            });
                            _context.next = 7;
                            return _api.SimilarItems.fetchSimilarItems({ authToken: authToken, deployment: deployment, similarItemInfo: similarItemInfo });

                        case 7:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), itemId: similarItemInfo.itemId },
                                payload: response,
                                type: LOAD_SIMILAR_ITEMS_SUCCESS
                            });
                            _context.next = 14;
                            break;

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { itemId: similarItemInfo.itemId },
                                payload: _context.t0,
                                type: LOAD_SIMILAR_ITEMS_FAIL
                            });

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 11]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

function fetchSimilarItemsIfNeeded(similarItemInfo) {
    return function (dispatch, getState) {
        if (similarItemInfo && shouldFetchSimilarItems(getState(), similarItemInfo.itemId)) {
            return dispatch(loadSimilarItems(similarItemInfo));
        }
        return _promise2.default.resolve();
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/similarItems.js
// module id = sjfW
// module chunks = 60